import React from "react"
import { ZendeskNavItemAndIcon } from "./NavItemAndIcon"
import { useIntl } from "react-intl"

function HelpCenterNav(): JSX.Element {
  const intl = useIntl()
  return (
    <ZendeskNavItemAndIcon
      icon="icn-support-buoy"
      id="nav-support-center-link"
      text={intl.formatMessage({
        defaultMessage: "Get help"
      })}
    />
  )
}

export { HelpCenterNav }
